<template>
	<div class="app-container">
	  
	  
	  <!-- 顶部标题栏 -->
	  <div class="header-bar">
		<button @click="goBack" class="back-btn"><i class="van-badge__wrapper van-icon van-icon-arrow-left van-nav-bar__arrow" style="font-size: 10px !important;"></i></button>
		<div class="title-center">
		  <div class="subtitle">{{ $t('certification.certOrderNo') }}</div>
		  <div class="main-title">{{lottery.now_expect}}</div>
		</div>
		<button class="record-btn" @click="goToRecord">
		  <span></span>{{ $t('certification.record') }}
		</button>
	  </div>
	  
	  <!-- 背景图（模糊） -->
	  <div class="bg-image"></div>
	  
	  <!-- 中心认证区域和产品 -->
	  <div class="auth-wrapper">
		<!-- 成功提示横幅 -->
		<div v-if="showSuccessNotify" class="success-notify">
			<div class="success-icon">✓</div>
			<div class="success-text">
			{{ $t('certification.certSuccess', { orderNo: successData.orderNo, deducted: successData.deducted, balance: successData.balance }) }}
			</div>
		</div>
		<!-- 中心认证按钮 -->
		<div class="center-auth">
			<div class="auth-circle">
			<div class="shield-icon">️</div>
			<div class="auth-text">{{ getCertTypeText() }}</div>
			<div class="time-label">{{ $t('certification.timeRemaining') }}</div>
			<div class="countdown" :class="{ 'countdown-zero': countdown === '00:00' }">{{ countdown }}</div>
			<div v-if="countdown === '00:00'" class="refresh-tip">{{ $t('certification.refreshing') }}</div>
		  </div>
		</div>
		
		<!-- 四个产品 - 围绕中心圆形排列 -->
		<!-- 上方左侧：催情水 -->
		<div 
		  class="action-item product-top-left" 
		  :class="{ active: selectedProducts.includes(1) }"
		  @click="toggleProduct(1)"
		>
		  <img :src="quickActions[0].icon" alt="" class="action-icon" />
		  <div class="action-label">{{ quickActions[0].label }}</div>
		</div>
		<!-- 上方右侧：润滑油 -->
		<div 
		  class="action-item product-top-right" 
		  :class="{ active: selectedProducts.includes(2) }"
		  @click="toggleProduct(2)"
		>
		  <img :src="quickActions[1].icon" alt="" class="action-icon" />
		  <div class="action-label">{{ quickActions[1].label }}</div>
		</div>
		<!-- 下方左侧：避孕套 -->
		<div 
		  class="action-item product-bottom-left" 
		  :class="{ active: selectedProducts.includes(3) }"
		  @click="toggleProduct(3)"
		>
		  <img :src="quickActions[2].icon" alt="" class="action-icon" />
		  <div class="action-label">{{ quickActions[2].label }}</div>
		</div>
		<!-- 下方右侧：按摩棒 -->
		<div 
		  class="action-item product-bottom-right" 
		  :class="{ active: selectedProducts.includes(4) }"
		  @click="toggleProduct(4)"
		>
		  <img :src="quickActions[3].icon" alt="" class="action-icon" />
		  <div class="action-label">{{ quickActions[3].label }}</div>
		</div>
	  </div>
  
	  
  
	  <!-- 积分输入区域 -->
	  <div class="points-section">
		
		<input
		  v-model.number="selectedPoints"
		  type="number"
		  min="0"
		  max="6680"
		  class="points-input"
		  :placeholder="$t('certification.enterPoints')"
		/>
		<div class="info-row">
		  {{ $t('certification.selectedItems', { count: selectedItems }) }}<br />
		  {{ $t('certification.estimatedDeduct', { amount: totalBetAmount }) }}
		</div>
		<div class="balance-btn-row">
		  <div class="balance-row">
			<span>{{ $t('certification.currentBalance') }}</span>
			<span class="balance-value">{{ accountBalance }} {{ $t('certification.points') }}</span>
		  </div>
		  <button @click="confirmAuth" class="confirm-btn">
			<span>✔️</span>{{ $t('certification.confirmCert') }}
		  </button>
		</div>
		<hr class="progress-hr">
		<!-- 订单进度显示 -->
		<div v-if="currentOrder" class="order-progress-card">
		<div class="progress-title">{{ $t('certification.currentProgress') }}</div>
		<div class="progress-steps">
			<div 
				v-for="(step, index) in orderSteps" 
				:key="index"
				class="progress-step-item"
				:class="{ 
					'active': step.step_type === certType,
					'completed': step.status === 1,
					'pending': step.status === 0 && step.step_type === certType && step.completed_count < step.required_count
				}"
			>
				<div class="step-name">{{ step.step_name }}</div>
				<div class="step-progress">
					<span class="progress-text">{{ step.completed_count }}/{{ step.required_count }}</span>
					<div class="progress-bar">
						<div 
							class="progress-fill" 
							:style="{ width: getProgressPercent(step) + '%' }"
						></div>
					</div>
				</div>
				<div v-if="step.step_type === certType && step.completed_count < step.required_count" class="step-status">
					{{ $t('certification.needComplete', { count: step.required_count - step.completed_count }) }}
				</div>
				<div v-else-if="step.status === 0 && step.step_type === certType" class="step-status waiting">
					{{ $t('certification.waitingSettlement') }}
				</div>
				<div v-else-if="step.status === 1" class="step-status completed">
					✓ {{ $t('certification.completed') }}
				</div>
			</div>
		</div>
	  </div>
	  </div>
	  
	  <!-- 底部导航栏 -->
	  <!-- <div class="footer-nav">
		<button v-for="tab in tabs" :key="tab.name" @click="switchTab(tab.name)" class="nav-item" :class="{ active: activeTab === tab.name }">
		  <div class="nav-icon">{{ tab.icon }}</div>
		  <div class="nav-text">{{ tab.text }}</div>
		</button>
	  </div> -->
	</div>
  </template>
  
  <script>
  export default {
	name: 'App',
	data() {
	  return {
		countdown: '03:00',
		timer: null,
		selectedPoints: '',
		selectedItems: 0,
		selectedProducts: [],
		accountBalance: 0,
		activeTab: '',
		lottery: {},
		xuanfeiData: {},
		lottery_id: null,
		userInfo: {},
		lottery_peilv_list: [],
		formData: [],
		certType: null, // 认证类型：car, hotel, confidential
		currentOrder: null, // 当前订单信息
		orderSteps: [], // 订单步骤信息
		orderConfig: null, // 订单配置
		showSuccessNotify: false,
		successData: {
		  orderNo: '',
		  deducted: 0,
		  balance: 0
		},
		notifyTimer: null,
		// 商品映射到大小单双：1=大, 2=小, 3=单, 4=双
		productTypeMap: {},
		quickActions: [],
		tabs: []
	  }
	},
	computed: {
	  totalBetAmount() {
		if (!this.selectedPoints || this.formData.length === 0) {
		  return 0
		}
		return this.formData.length * this.selectedPoints
	  }
	},
	mounted() {
	  // 初始化tabs
	  this.tabs = [
		{ name: 'Home', icon: 'ℹ️', text: this.$t('common.home') || 'Home' },
		{ name: 'Video', icon: '▶️', text: this.$t('common.video') || 'Video' },
		{ name: 'Choose', icon: '❤️', text: this.$t('common.choose') || 'Choose' },
		{ name: 'Pl', icon: '⭐', text: this.$t('common.review') || 'Review' },
		{ name: 'Mine', icon: '', text: this.$t('common.my') || 'My' }
	  ]
	  // 初始化商品类型映射
	  this.productTypeMap = {
		1: { type: this.$t('game.da') || '大', name: 'da' },
		2: { type: this.$t('game.xiao') || '小', name: 'xiao' },
		3: { type: this.$t('game.dan') || '单', name: 'dan' },
		4: { type: this.$t('game.shuang') || '双', name: 'shuang' }
	  }
	  // 初始化商品列表
	  this.quickActions = [
		{ label: this.$t('certification.product1'), icon: '/img/v1.png' },
		{ label: this.$t('certification.product2'), icon: '/img/v2.png' },
		{ label: this.$t('certification.product3'), icon: '/img/v3.png' },
		{ label: this.$t('certification.product4'), icon: '/img/v4.png' }
	  ]
	  // 不再从路由参数获取认证类型，而是根据订单进度自动判断
	  this.initData()
	},
	beforeDestroy() {
	  if (this.timer) clearInterval(this.timer)
	  if (this.notifyTimer) clearTimeout(this.notifyTimer)
	},
	methods: {
	  initData() {
		if (!localStorage.getItem('token')) {
		  this.$router.push({ path: '/Login' })
		  return
		}
		this.getUserInfo()
		this.getXuanfeiData()
		// 先获取订单信息，根据订单进度判断认证类型
		this.getCurrentOrder()
		this.getOrderConfig()
		this.startCountdown()
	  },
	  getXuanfeiData() {
		const id = this.$route.query.id
		if (!id) {
		  this.$toast.fail(this.$t('profile.missingParams'))
		  return
		}
		this.$http({
		  method: 'get',
		  url: 'xuanfeidata',
		  data: { id: id }
		}).then(res => {
		  if (res.code === 200) {
			// 保存选妃数据（包含 sn 字段）
			this.xuanfeiData = res.data
			if (res.data.lottery) {
			  this.lottery = res.data.lottery
			  // 保存 lottery_id
			  this.lottery_id = res.data.lottery.id
			  this.getLotteryInfo()
			  this.getLotteryPeilv()
			}
		  }
		}).catch(() => {
		  this.$toast.fail(this.$t('certification.getDataFailed'))
		})
	  },
	  getLotteryInfo() {
		if (!this.lottery.key) return
		this.$http({
		  method: 'get',
		  data: { key: this.lottery.key },
		  url: 'lottery_get_info'
		}).then(res => {
		  if (res.code === 200) {
			this.lottery = { ...this.lottery, ...res.data }
			if (res.data.second) {
			  // 更新倒计时
			  const totalSec = res.data.second
			  const min = Math.floor(totalSec / 60)
			  const sec = totalSec % 60
			  this.countdown = `${String(min).padStart(2, '0')}:${String(sec).padStart(2, '0')}`
			  // 重新启动倒计时
			  if (this.timer) clearInterval(this.timer)
			  this.startCountdown()
			}
		  }
		})
	  },
	  getLotteryPeilv() {
		if (!this.lottery.id) return
		this.$http({
		  method: 'get',
		  data: { id: this.lottery.id },
		  url: 'lottery_get_peilv'
		}).then(res => {
		  if (res.code === 200) {
			this.lottery_peilv_list = res.data
		  }
		})
	  },
	  getUserInfo() {
		this.$http({
		  method: 'get',
		  url: 'user_info'
		}).then(res => {
		  if (res.code === 200) {
			this.userInfo = res.data
			this.accountBalance = res.data.money || 0
		  }
		})
	  },
	  startCountdown() {
		if (this.timer) clearInterval(this.timer)
		this.timer = setInterval(() => {
		  const [min, sec] = this.countdown.split(':').map(Number)
		  if (min === 0 && sec === 0) {
			// 倒计时为0时，刷新获取新的期号
			this.countdown = '00:00'
			this.refreshLotteryInfo()
		  } else {
			let totalSec = min * 60 + sec - 1
			const newMin = Math.floor(totalSec / 60)
			const newSec = totalSec % 60
			this.countdown = `${String(newMin).padStart(2, '0')}:${String(newSec).padStart(2, '0')}`
		  }
		}, 1000)
	  },
	  refreshLotteryInfo() {
		// 刷新彩票信息，获取新的期号
		if (this.lottery && this.lottery.key) {
		  this.getLotteryInfo()
		} else if (this.xuanfeiData && this.xuanfeiData.lottery) {
		  this.getXuanfeiData()
		}
	  },
	  getCurrentOrder() {
		// 获取当前订单信息（需要传递beauty_id，每个美女的订单是独立的）
		const beautyId = this.$route.query.id || this.xuanfeiData.id
		if (!beautyId) {
		  return
		}
		this.$http({
		  method: 'get',
		  url: 'get_current_order',
		  data: { beauty_id: beautyId }
		}).then(res => {
		  if (res.code === 200 && res.data) {
			this.currentOrder = res.data
			this.orderSteps = res.data.steps || []
			// 根据订单进度自动判断认证类型
			this.determineCertType()
			// 定时刷新订单进度
			setTimeout(() => {
			  this.getCurrentOrder()
			}, 5000) // 每5秒刷新一次
		  } else {
			// 没有订单，默认车费认证
			this.certType = 'car'
		  }
		}).catch(() => {
		  // 获取订单失败，默认车费认证
		  this.certType = 'car'
		})
	  },
	  determineCertType() {
		// 根据订单步骤判断当前应该进行的认证类型
		if (this.orderSteps && this.orderSteps.length > 0) {
		  // 查找第一个未完成的步骤
		  const unfinishedStep = this.orderSteps.find(step => step.status === 0)
		  if (unfinishedStep) {
			// 找到未完成的步骤，使用该步骤的类型
			this.certType = unfinishedStep.step_type
		  } else {
			// 所有步骤都完成了，根据current_step确定
			if (this.currentOrder.current_step === 1) {
			  this.certType = 'car'
			} else if (this.currentOrder.current_step === 2) {
			  this.certType = 'hotel'
			} else if (this.currentOrder.current_step === 3) {
			  this.certType = 'confidential'
			} else {
			  // 默认车费认证
			  this.certType = 'car'
			}
		  }
		} else {
		  // 没有步骤信息，根据current_step确定
		  if (this.currentOrder.current_step === 1) {
			this.certType = 'car'
		  } else if (this.currentOrder.current_step === 2) {
			this.certType = 'hotel'
		  } else if (this.currentOrder.current_step === 3) {
			this.certType = 'confidential'
		  } else {
			// 默认车费认证
			this.certType = 'car'
		  }
		}
	  },
	  getOrderConfig() {
		// 获取订单配置
		this.$http({
		  method: 'get',
		  url: 'order_getConfig'
		}).then(res => {
		  if (res.code === 200 && res.data) {
			this.orderConfig = res.data
		  }
		}).catch(() => {
		  // 获取配置失败
		})
	  },
	  getProgressPercent(step) {
		if (!step.required_count || step.required_count === 0) return 0
		return Math.floor((step.completed_count / step.required_count) * 100)
	  },
	  confirmAuth() {
		// 下注提交逻辑
		if (this.selectedPoints === '' || this.selectedPoints === 0) {
		  this.$toast(this.$t('game.plsmoney') || '请输入下注金额')
		  return false
		}
		if (this.formData.length === 0) {
		  this.$toast(this.$t('game.plsnum') || '请选择下注选项')
		  return false
		}
		if (this.userInfo.money - this.totalBetAmount < 0) {
		  this.$toast(this.$t('game.moneynote') || '积分不足')
		  return false
		}
		if (!this.lottery.id || !this.lottery.now_expect) {
		  this.$toast(this.$t('certification.getLotteryFailed'))
		  return false
		}
		
		// 构建下注项字符串
		let gameitem = ''
		for (let j = 0; j < this.formData.length; j++) {
		  if (j === 0) {
			gameitem = this.formData[j]['type']
		  } else {
			gameitem += ',' + this.formData[j]['type']
		  }
		}
		
		// 获取beauty_id
		const beautyId = this.$route.query.id || this.xuanfeiData.id
		if (!beautyId) {
		  this.$toast.fail(this.$t('certification.missingBeautyId'))
		  return false
		}
		
		this.$http({
		  method: 'post',
		  data: {
			item: gameitem,
			money: this.selectedPoints,
			lid: this.lottery.id,
			mid: this.userInfo.id,
			expect: this.lottery.now_expect,
			certType: this.certType || 'car', // 传递认证类型
			beauty_id: beautyId // 传递美女ID，每个美女的订单是独立的
		  },
		  url: 'game_place_order'
		}).then(res => {
		  if (res.code === 200) {
			// 计算扣除后的余额
			const newBalance = this.userInfo.money - this.totalBetAmount
			
			// 显示成功提示
			this.successData = {
			  orderNo: this.lottery.now_expect || this.xuanfeiData.sn || '',
			  deducted: this.totalBetAmount,
			  balance: newBalance
			}
			this.showSuccessNotify = true
			
			// 3秒后自动隐藏
			if (this.notifyTimer) clearTimeout(this.notifyTimer)
			this.notifyTimer = setTimeout(() => {
			  this.showSuccessNotify = false
			}, 3000)
			
			this.allClear()
			// 更新用户信息（获取最新余额）
			this.getUserInfo()
			// 刷新订单进度
			this.getCurrentOrder()
		  } else if (res.code === 401) {
			this.$toast.fail(res.msg || this.$t('certification.betFailed'))
		  }
		}).catch(() => {
		  this.$toast.fail(this.$t('certification.betFailedRetry'))
		})
	  },
	  allClear() {
		this.selectedProducts = []
		this.formData = []
		this.selectedItems = 0
		this.selectedPoints = ''
	  },
	  goBack() {
		return window.history.back();
	  },
	  goToRecord() {
		// 传递 lottery_id 参数
		const query = {}
		if (this.lottery_id) {
		  query.lottery_id = this.lottery_id
		}
		this.$router.push({ 
		  path: '/CertificationRecord',
		  query: query
		})
	  },
	  switchTab(tabName) {
		this.activeTab = tabName
		const query = {}
		this.$router.push({
		  path: '/'+ tabName,
		  query: query
		})
	  },
	  toggleProduct(productId) {
		// 商品1、2、3、4对应大小单双
		const productType = this.productTypeMap[productId]
		if (!productType) return
		
		const index = this.selectedProducts.indexOf(productId)
		if (index > -1) {
		  // 取消选择
		  this.selectedProducts.splice(index, 1)
		  // 从 formData 中移除
		  for (let i = 0; i < this.formData.length; i++) {
			if (productType.type === this.formData[i]['type']) {
			  this.formData.splice(i, 1)
			  break
			}
		  }
		} else {
		  // 选择
		  this.selectedProducts.push(productId)
		  // 添加到 formData
		  this.formData.push({
			name: productType.name,
			type: productType.type
		  })
		}
		this.selectedItems = this.formData.length
	  },
	  getCertTypeText() {
		// 根据认证类型返回对应的文本
		const certTypeMap = {
		  'car': this.$t('certification.carCert'),
		  'hotel': this.$t('certification.hotelCert'),
		  'confidential': this.$t('certification.confidentialCert')
		}
		return certTypeMap[this.certType] || this.$t('certification.carCert')
	  }
	}
  }
  </script>
  
  <style scoped>
  .app-container {
	position: relative;
	min-height: 100vh;
	background: #000;
	color: white;
	overflow-y: auto;
	overflow-x: hidden;
	font-family: Arial, sans-serif;
	/* 隐藏滚动条但保持滚动功能 */
	scrollbar-width: none !important; /* Firefox */
	-ms-overflow-style: none !important; /* IE 和 Edge */
  }
  
  /* 隐藏滚动条但保持滚动功能 - Chrome, Safari, Opera */
  .app-container::-webkit-scrollbar {
	width: 0px !important;
	height: 0px !important;
	background: transparent !important;
	display: none !important;
  }
  
  .app-container::-webkit-scrollbar-track {
	display: none !important;
  }
  
  .app-container::-webkit-scrollbar-thumb {
	display: none !important;
  }
  
  /* 如果需要显示细滚动条，可以使用以下样式替代上面的隐藏样式 */
  /*
  .app-container::-webkit-scrollbar {
	width: 4px;
  }
  
  .app-container::-webkit-scrollbar-track {
	background: rgba(0, 0, 0, 0.1);
	border-radius: 2px;
  }
  
  .app-container::-webkit-scrollbar-thumb {
	background: rgba(236, 72, 153, 0.5);
	border-radius: 2px;
  }
  
  .app-container::-webkit-scrollbar-thumb:hover {
	background: rgba(236, 72, 153, 0.8);
  }
  */
  
  /* 成功提示横幅 */
  .success-notify {
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	background: #00c853;
	color: white;
	padding: 16px 20px;
	display: flex;
	align-items: center;
	gap: 12px;
	z-index: 9999;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
	animation: slideDown 0.3s ease-out;
  }
  
  @keyframes slideDown {
	from {
	  transform: translateY(-100%);
	  opacity: 0;
	}
	to {
	  transform: translateY(0);
	  opacity: 1;
	}
  }
  
  .success-icon {
	width: 24px;
	height: 24px;
	border-radius: 50%;
	background: white;
	color: #00c853;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 16px;
	font-weight: bold;
	flex-shrink: 0;
  }
  
  .success-text {
	flex: 1;
	font-size: 16px;
	line-height: 1.4;
	font-weight: 500;
  }
  
  /* 顶部标题栏 */
  .header-bar {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 25px 16px;
	background: url(/img/header.svg) no-repeat 50%/100%;
	position: relative;
	z-index: 10;
	height: 3rem;
  }
  
  .back-btn {
	font-size: 28px;
	background: none;
	border: none;
	color: white;
	cursor: pointer;
  }
  
  .title-center {
	text-align: center;
	flex: 1;
  }
  
  .subtitle {
	font-size: 18px;
	opacity: 0.8;
  }
  
  .main-title {
	font-size: 30px;
	font-weight: bold;
  }
  
  .record-btn {
	display: flex;
	align-items: center;
	gap: 6px;
	background: #ec4899;
	color: white;
	border: none;
	padding: 8px 16px;
	border-radius: 20px;
	font-size: 20px;
	cursor: pointer;
  }
  
  /* 背景图 */
  .bg-image {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background: url('http://www.desire-club.top/xuanfei/20241022/7bf5bf8a20b306cf1706f8d9eab4b76c.jpg') no-repeat center center;
	background-size: cover;
	filter: blur(2px);
	opacity: 0.4;
	z-index: 0;
  }
  
  /* 认证区域包装器 */
  .auth-wrapper {
	position: relative;
	width: 100%;
	min-height: 800px;
	display: flex;
	justify-content: center;
	align-items: center;
	margin-top: 0;
	z-index: 5;
	pointer-events: none;
  }
  
  .auth-wrapper > * {
	pointer-events: auto;
  }

  /* 中心认证按钮 */
  .center-auth {
	display: flex;
	justify-content: center;
	align-items: center;
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	z-index: 5;
  }
  
  .auth-circle {
	width: 380px;
	height: 380px;
	border-radius: 50%;
	background: #000;
	border: 8px solid #ec4899;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	box-shadow: 0 0 20px rgba(236, 72, 153, 0.6);
	position: relative;
  }
  
  .shield-icon {
	font-size: 48px;
	margin-bottom: 12px;
  }
  
  .auth-text {
	font-size: 24px;
	font-weight: bold;
	margin-bottom: 10px;
  }
  
  .time-label {
	font-size: 16px;
	background: #7c1d4f;
	padding: 6px 12px;
	border-radius: 12px;
	margin-bottom: 8px;
  }
  
  .countdown {
	font-size: 32px;
	font-weight: bold;
	color: #ec4899;
	transition: color 0.3s;
  }
  
  .countdown-zero {
	color: #ff4444;
	animation: blink 1s infinite;
  }
  
  @keyframes blink {
	0%, 100% { opacity: 1; }
	50% { opacity: 0.5; }
  }
  
  .refresh-tip {
	font-size: 14px;
	color: #ff4444;
	margin-top: 8px;
  }
  
  /* 订单进度卡片 */
  .order-progress-card {
	position: relative;
	margin: 20px 16px;
	background: rgba(0, 0, 0, 0.85);
	border: 2px solid #ec4899;
	border-radius: 12px;
	padding: 20px;
	z-index: 10;
	max-width: 96%;
	margin-left: auto;
	margin-right: auto;
  }
  
  .progress-title {
	font-size: 20px;
	font-weight: bold;
	color: #ec4899;
	margin-bottom: 16px;
	text-align: center;
  }
  
  .progress-steps {
	display: flex;
	flex-direction: column;
	gap: 12px;
  }
  
  .progress-step-item {
	padding: 12px;
	background: rgba(255, 255, 255, 0.05);
	border-radius: 8px;
	border: 2px solid transparent;
	transition: all 0.3s;
  }
  
  .progress-step-item.active {
	border-color: #ec4899;
	background: rgba(236, 72, 153, 0.1);
  }
  
  .progress-step-item.completed {
	border-color: #00c853;
	background: rgba(0, 200, 83, 0.1);
  }
  
  .step-name {
	font-size: 18px;
	font-weight: bold;
	color: #fff;
	margin-bottom: 8px;
  }
  
  .step-progress {
	display: flex;
	align-items: center;
	gap: 12px;
	margin-bottom: 6px;
  }
  
  .progress-text {
	font-size: 16px;
	color: #ec4899;
	font-weight: bold;
	min-width: 60px;
  }
  
  .progress-bar {
	flex: 1;
	height: 8px;
	background: rgba(255, 255, 255, 0.1);
	border-radius: 4px;
	overflow: hidden;
  }
  
  .progress-fill {
	height: 100%;
	background: linear-gradient(90deg, #ec4899, #ff6b9d);
	border-radius: 4px;
	transition: width 0.3s;
  }
  
  .step-status {
	font-size: 14px;
	color: #aaa;
	margin-top: 4px;
  }
  
  .step-status.waiting {
	color: #ffa726;
  }
  
  .step-status.completed {
	color: #00c853;
	font-weight: bold;
  }
  
  /* 产品按钮 - 绝对定位围绕中心圆形 */
  .action-item {
	position: absolute;
	background: rgba(0, 0, 0, 0.7);
	border: 3px solid #8b8b8b;
	border-radius: 16px;
	padding: 20px;
	display: flex;
	flex-direction: column;
	align-items: center;
	cursor: pointer;
	width: 150px;
	min-height: 150px;
	transition: all 0.3s;
	z-index: 6;
	margin-top:50px;
  }

  .action-item.active {
	background: rgba(236, 72, 153, 0.3);
	border-color: #ec4899;
	box-shadow: 0 0 25px rgba(236, 72, 153, 0.7);
	transform: scale(1.05);
  }

  .action-item:active {
	transform: scale(0.95);
  }

  /* 产品位置 */
  .product-top-left {
	top: 30px;
	left: 30px;
  }

  .product-top-right {
	top: 30px;
	right: 30px;
  }

  .product-bottom-left {
	bottom: 0;
	left: 30px;
  }

  .product-bottom-right {
	bottom: 0;
	right: 30px;
  }
  
  .action-icon {
	width: 70px;
	height: 70px;
	border-radius: 50%;
	margin-bottom: 12px;
  }
  
  .action-label {
	font-size: 18px;
	font-weight: 500;
  }
  
  /* 积分输入区域 */
  .points-section {
	background: #000;
	border: 2px solid #ec4899;
	border-radius: 12px;
	padding: 25px;
	margin: 20px 16px;
	z-index: 10;
	position: relative;
	/* margin-bottom: 150px; */
  }
  
  .points-input {
	width: 100%;
	padding: 20px;
	background: transparent;
	border: 2px solid #ec4899;
	border-radius: 8px;
	color: white;
	font-size: 28px;
	text-align: left;
	outline: none;
	font-weight: bold;
	box-sizing: border-box;
	position: relative;
	z-index: 11;
	pointer-events: auto;
  }
  
  .points-input::placeholder {
	color: #666;
	font-size: 28px;
  }
  .progress-hr {
	margin-top: 40px;
	margin-bottom: 40px;
	border: none;
	border-top: 0.5px dashed #7c7c7c;
  }
  .info-row {
	font-size: 24px;
	color: #aaa;
	margin-top: 20px;
	line-height: 1.6;
	text-align: left;
  }
  
  .balance-btn-row {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-top: 30px;
	gap: 16px;
  }
  
  .balance-row {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	flex: 1;
	font-size: 24px;
  }
  
  .balance-value {
	font-size: 38px;
	font-weight: bold;
	color: #ec4899;
	margin-top: 0px;
  }
  
  .confirm-btn {
	flex: 0 0 auto;
	padding: 22px 30px;
	background: linear-gradient(90deg,#df35ad,#4f1db5);
	border: none;
	border-radius: 24px;
	color: white;
	font-weight: bold;
	font-size: 32px;
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 10px;
	white-space: nowrap;
  }
  
  /* 底部导航栏 */
  .footer-nav {
	position: fixed;
	bottom: 0;
	left: 0;
	right: 0;
	background: none;
	border-top: 2px solid #ec4899;
	display: flex;
	justify-content: space-around;
	padding: 8px 0;
	z-index: 100;
  }
  
  .nav-item {
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 8px 0;
	font-size: 16px;
	color: #fff;
	cursor: pointer;
	transition: color 0.2s;
	background: none;
    border: none;
  }
  
  .nav-item.active {
	color: #ec4899;
  }
  
  .nav-icon {
	font-size: 28px;
	margin-bottom: 6px;
  }
  
  .nav-text {
	font-size: 28px;
  }
  </style>
  
  <style>
  /* 全局隐藏滚动条 - 最彻底的方法 */
  * {
	scrollbar-width: none !important; /* Firefox */
	-ms-overflow-style: none !important; /* IE 和 Edge */
  }
  
  *::-webkit-scrollbar {
	width: 0px !important;
	height: 0px !important;
	display: none !important;
	background: transparent !important;
  }
  
  *::-webkit-scrollbar-track {
	display: none !important;
	background: transparent !important;
  }
  
  *::-webkit-scrollbar-thumb {
	display: none !important;
	background: transparent !important;
  }
  
  *::-webkit-scrollbar-corner {
	display: none !important;
	background: transparent !important;
  }
  
  html, body {
	scrollbar-width: none !important;
	-ms-overflow-style: none !important;
	overflow-x: hidden !important;
  }
  
  html::-webkit-scrollbar,
  body::-webkit-scrollbar {
	width: 0px !important;
	height: 0px !important;
	display: none !important;
	background: transparent !important;
  }
  
  html::-webkit-scrollbar-track,
  body::-webkit-scrollbar-track {
	display: none !important;
	background: transparent !important;
  }
  
  html::-webkit-scrollbar-thumb,
  body::-webkit-scrollbar-thumb {
	display: none !important;
	background: transparent !important;
  }
  </style>
  